
import Vue from 'vue'
import errorHandler from '@/utils/errorHandler'

import moment from 'moment'

const transformer = ({ oldRevi, newRevi, status, onlyStatus, dateFrom, dateTo }) => {
  return {
    from: dateFrom ? moment(dateFrom).format('YYYY/MM/DD'): null,
    to: dateTo ? moment(dateTo).format('YYYY/MM/DD'): null,
    old_revi: oldRevi,
    new_revi: newRevi,
    only_status: onlyStatus ? status : undefined,
    under_in_status: !onlyStatus ? status : undefined
  }
}

export default (reassignation) =>
  errorHandler(Vue.$http.post('sinisters/update_revi/', transformer(reassignation)))
    .then(response => response.data)



// WEBPACK FOOTER //
// ./src/services/sinister/bulkReviReassignation.js